import "./LoadingOverlay.html";
import "./LoadingOverlay.scss";
import "./StretchParentDirective";

import type { IComponentOptions } from "angular";
import { LoadingOverlayComponentController } from "./LoadingOverlayComponentController";

export class LoadingOverlayComponent implements IComponentOptions {
    public bindings = {
        isLoading: "<",
    };

    public controller = LoadingOverlayComponentController;

    public templateUrl = "/App/Modules/Gui/Components/PageLoadingOverlay/LoadingOverlay.html";
}
